import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// coraWebComponents
import Button from "../../coraWebComponents/buttons/Button";
import Tooltip from "../../coraWebComponents/forms/Tooltip";
import Input from "../../coraWebComponents/forms/Input";
import LoadingPanel from "../../coraWebComponents/LoadingPanel";
import withRouter from '../../coraWebComponents/utils/withRouter';
import InfoData from "./InfoData";
// actions
import * as userActions from "../../actions/userActions";
import * as loginActions from "../../actions/loginActions";

// proptypes
import userPropTypes from "../../propTypes/userPropTypes";
import Routes from "../../constants/Routes";
import * as userUtils from "../../utils/userUtils";

class InfoUser extends React.Component {
  constructor(props) {
    super(props);

    const user = props.user.Uzivatel;
    this.state = {
      data: {
        ...user, ...userUtils.formatUzivatel(user),
      }
    };
  }

  handleOnClickCancel = () => {
    this.props.navigate(-1);
  };

  handleOnSubmit = async (event) => {
    event.preventDefault();
    const { updateUser, refreshUser, navigate } = this.props;
    const { data } = this.state;
    const { meno, priezvisko, nazov, ico, radioValue, ulica, cs, co, psc, obec, telefon, email } = data;

    await updateUser({
      ...data,
      Osoba: {
        OsobneUdaje: { meno, priezvisko, nazov, ico, I_O_TYP: radioValue.value === "fyzOsoba" ? 1 : 2 },
        Adresa: { ulica, cs, co, psc, obec },
        Kontakt: { telefon, email },
      }
    });
    await refreshUser();
    navigate(Routes.HOME);
  };

  handleOnChange = (name, value) => {
    this.setState((state) => ({
      data: { ...state.data, [name]: value },
    }));
  };

  renderHeslo = (data) => {
    return (
      <>
        <div className="k-form-field">
          <span>Nové heslo</span>
          <Input
            title={""}
            type="password"
            name="HESLO"
            onChange={this.handleOnChange}
            value={data.HESLO}
            pattern="(?=.*[a-z].*)(?=.*[A-Z].*)(?=.*[0-9].*)(?=.*[@$!%*?#^\+\-/.].*)^[a-zA-Z0-9@$!%*?#^\+\-/.]{8,}"
            validationMessage="Heslo musí pozostávať aspoň z 8 znakov a musí obsahovať aspoň 
                            jeden znak a-z, 
                            jeden znak A-Z, 
                            jeden znak 0-9 a 
                            jeden zo znakov: +-*/@?!%$#^."
          />
        </div>
      </>)
  }

  render() {
    const { isLoading } = this.props;
    const { data } = this.state;

    return (
      <div className={"row m-0"}>
        <div className="col-6 offset-3 p-0 forWeb">
          <div className="card formular">
            <div className="form-body">
              {/* FORM */}
              <Tooltip>
                <form
                  id={"webFormInfoUser"}
                  className="k-form"
                  onSubmit={this.handleOnSubmit}
                >
                  {/* TITLE */}
                  <div className="card-title">
                    <div>Profil používateľa {data.N_UZ}</div>
                  </div>
                  <p>&nbsp;</p>

                  <InfoData
                    infoData={data}
                    mobile={false}
                    onChange={this.handleOnChange}
                    emailDisabled={true}
                  />

                  {this.renderHeslo(data)}

                  {/* BUTTONS */}
                  <div className="k-form-field flexGroup">
                    <Button primary label="Zrusiť" onClick={this.handleOnClickCancel} />
                    <div className="flexGroup">
                      <Button type="submit" label="Uložiť" primary={true} />
                    </div>
                  </div>
                </form>
              </Tooltip>
            </div>
          </div>
        </div>
        <div className="col p-0 forMobile">
          <div className="card formular">
            <div className="form-body">
              {/* FORM */}
              <Tooltip>
                <form
                  id={"webMobileInfoUser"}
                  className="k-form"
                  onSubmit={this.handleOnSubmit}
                >
                  {/* TITLE */}
                  <div className="card-title">
                    <div>Profil používateľa {data.N_UZ}</div>
                  </div>

                  <p>&nbsp;</p>

                  <InfoData
                    infoData={data}
                    mobile={true}
                    onChange={this.handleOnChange}
                    emailDisabled={true}
                  />

                  {this.renderHeslo(data)}

                  {/* BUTTONS */}
                  <div className="k-form-field flexGroup">
                    <Button primary label="Zrusiť" onClick={this.handleOnClickCancel} />
                    <div className="flexGroup">
                      <Button type="submit" label="Uložiť" primary={true} />
                    </div>
                  </div>
                </form>
              </Tooltip>
            </div>
          </div>
        </div>
        <LoadingPanel isLoading={isLoading} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.data,
    isLoading: state.user.isLoading,
  };
};

const mapDispatchToProps = (dispatch) => ({
  updateUser: async (data) => await dispatch(userActions.updateUser(data)),
  refreshUser: async () => await dispatch(loginActions.refreshUser()),
});

InfoUser.propTypes = {
  user: userPropTypes.user,
  updateUser: PropTypes.func,
  refreshUser: PropTypes.func,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(InfoUser)
);
